import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ProductVendor } from "@app/main/components/videos/enums/CameraProductType";
import { DateService } from "@app/services/date.service";
import { Observable } from "rxjs";

export interface IUnitLogRequestOptions {
    serial: string;
    start: Date;
    end: Date;
}

export interface IUnitLog {
    Id: number;
    AccountId?: number;
    Serial: string;

    Timestamp: string;
    TimestampInserted: string

    Raw: string;
    HostDescription: string;
    EventType: string;

    ProcessingTime: number;

    ProductType: ProductVendor;

    Errored: boolean;
    ErrorMessage: string;
}

@Injectable()
export class UnitLogService {
    constructor(
        private readonly http: HttpClient,
        private readonly dateService: DateService) {
    }

    getLogs(options: IUnitLogRequestOptions): Observable<IUnitLog[]> {

        const params = this.createHttpParams(options);

        var response = this.http.get<IUnitLog[]>(`/api/units/logs/${options.serial}`, { params: params });

        return response;
    }

    // ---

    private createHttpParams(options?: IUnitLogRequestOptions): HttpParams {
        let params = new HttpParams();

        if (!options) {
            return params;
        }

        if (options.start) {
            params = params.set("start", options.start.toISOString())
        }

        if (options.end) {
            params = params.set("end", options.end.toISOString())
        }

        return params;
    }
}
